import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class BygningsstatusHistorikk extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleBygningsstatusHistorikk = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var bygningsstatusHistorikk = this.props.bygningsstatushistorikk

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleBygningsstatusHistorikk}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{bygningsstatusHistorikk.bygningsstatusKode} <Moment local>{bygningsstatusHistorikk.registrertDato}</Moment></span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bygningsstatuskode')}</div>
                            <div className="value">{bygningsstatusHistorikk.bygningsstatusKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('dato')}</div>
                            <div className="value"><Moment local>{bygningsstatusHistorikk.dato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('registrertdato')}</div>
                            <div className="value"><Moment local>{bygningsstatusHistorikk.registrertDato}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('arsaktilforingkode')}</div>
                            <div className="value"><Moment local>{bygningsstatusHistorikk.arsaktilforingkode}</Moment></div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(BygningsstatusHistorikk)